import LogoEN from '@CS/assets/logo-en.png';

export default {
  hr: LogoEN,
  en: LogoEN
};
